import { Box } from '@mui/material'
import { SvgCarretDownIcon, SvgCarretLeftIcon } from 'components/common/LeftPanel/LeftPanel.styled'
import React, { FC, useState } from 'react'

interface DropDownProps {
  headerComponent: any
  bodyComponent: any
  indent?: boolean
}

export const SvgCaret = ({
  iconColor = '#666666',
  width = '24',
  height = '24',
  open = false,
}: {
  iconColor?: string
  width?: string
  height?: string
  open?: boolean
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      stroke={iconColor}
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
      className='feather feather-chevron-down svelte-zz2f49'
      // style='transform: rotate(90deg);width:1em;height:1em'
      style={{ transform: `rotate(${open ? 90 : 0}deg)` }}
    >
      <g>
        <polyline points='6 9 12 15 18 9' />
      </g>
    </svg>
  )
}

const DropDown: FC<DropDownProps> = (props) => {
  const { headerComponent, bodyComponent, indent = true } = props
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <Box flex={1} display={'flex'} flexDirection='column' alignItems={'flex-start'}>
      <Box
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{ cursor: 'pointer' }}
        display={'flex'}
        flexDirection={'row'}
        alignItems='center'
        gap={'4px'}
        marginBottom={'24px'}
        width='100%'
        maxWidth={'1550px'}
      >
        <Box display={'inline-block'}> {headerComponent}</Box>
        <SvgCaret open={isOpen} />
      </Box>
      <Box paddingLeft={indent ? '15px' : undefined} marginBottom={'20px'} display={isOpen ? 'block' : 'none'}>
        {bodyComponent}
      </Box>
    </Box>
  )
}

export default DropDown
